import axios, { secondAxios } from "../../../../../../../api/axios";
import { tokenHeader } from "../tokenHeader";

// export const createTask = async ({ task, projectId }) => {
export const createTask = async ({ task, projectId, accessToken }) => {
  console.log("creating task", task, projectId);
  // send task along with projectId(from URI / state)
  if (task.taskCode) {
  }
  console.log("ttt", { ...task, projectId });

  return await secondAxios.post(
    "/task/create",
    { ...task, estimatedTime: Number(task.estimatedTime), projectId },
    tokenHeader(accessToken)
  );
};

export const getAllTasks = async ({ projectId, accessToken, catList }) => {
  console.log("getting taskss", projectId);
  const { data } = await secondAxios.get(
    "/task/all/" + projectId,
    tokenHeader(accessToken)
  );
  console.log("tasks ddddata", data);
  if (catList?.length > 0) {
    const newCat = catList.map((c) => `${c.title}`);
    console.log("newcat", newCat);
    return data.filter((d) => newCat.includes(d.taskCode));
  }
  return data;
};

export const getOneTask = async () => {};

export const updateTask = async ({ task, accessToken }) => {
  console.log("updating task", task);
  return await secondAxios.patch(
    `/task/${task.id}`,
    { ...task, estimatedTime: Number(task.estimatedTime) || 0 },

    tokenHeader(accessToken)
  );
};

export const deleteTask = async ({ taskId }) => {};

export const archiveTask = async ({ id, accessToken }) => {
  return await secondAxios.patch(
    "/task/archive/" + id,
    id,
    tokenHeader(accessToken)
  );
};
